import PropTypes from 'prop-types';
import React from 'react';
import propTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { linkWithParams } from '../../routes';

const ChatPanelTop = ({ info, isASQEnabledForPartner }) => {
  return (
    <div className="o-communication__chat-panel-top">
      <div className="o-communication__chat-panel-top--info u-txt--bold">
        <div>{`To: ${info.accountName} - caregiver of`}</div>
        <div className="o-communication__chat-panel-top--name">
          <div className="o-avatar o-communication__chat-panel-top--avatar">
            <img src={info.playerAvatarUrl} alt=""/>
          </div>
          <div>{info.playerName}</div>
        </div>
      </div>
      <div className="o-communication__chat-panel-top--buttons">
        <Link to={linkWithParams('accountPlayer', {id: info.playerId})}
              className="o-sp-button o-sp-button--update o-sp-button--profile u-float--right u-margin-right--base"
              target="_blank">
          View Profile
        </Link>
        {isASQEnabledForPartner &&
          <Link to={`/dashboard/asqs?order=desc&player=${info.playerId}`}
                className="o-sp-button o-sp-button--update o-sp-button--primary u-float--right"
                target="_blank">
            ASQ Results
          </Link>}
      </div>
    </div>
  )
}

ChatPanelTop.propTypes = {
  info: PropTypes.shape({
    accountName: propTypes.string,
    playerAvatarUrl: propTypes.string,
    playerName: propTypes.string,
    playerId: propTypes.number,
  }).isRequired,
  isASQEnabledForPartner: PropTypes.bool.isRequired,
}

export default ChatPanelTop;
